export const colorTheme = {
  white: '#FFFFFF',
  black: '#000000',
  fCard1Bg: '#e8f9f9',
  fCard2Bg: '#fff8ea',
  fCard3Bg: '#e1f9ff',
  inputBorder: '#e9e9e9',
  stethoscope: '#1dbfc1',
  calenderIcon: '#ffa800',
  locationIcon: '#00D0FF',
  reidButton: '#2aa2db',
  slideTag: '#35dc7e',
  navBarTitle: '#292121',
  footerBottom: '#2d5fad',
  reidSignBg: 'rgb(241, 241, 241)',
  primaryBlue: '#2aa2db',
  primaryGreen: '#4cb848',
  primaryOrange: '#f1592f',
  primaryYellow: '#f5b02c',
};
